<template lang="html">
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  	 viewBox="0 0 60 60" style="enable-background:new 0 0 59 59;" xml:space="preserve">
     <g>
       <ellipse :style="{'fill': circleFill}" cx="30" cy="30" rx="30" ry="30"/>
     </g>

    <g transform="scale(.7) translate(10 15)">
    	<path style="fill:#46B29D;" d="M30.22,5L1.241,34.218c-0.987,0.987-0.987,2.588,0,3.576l20.466,20.466
    		c0.987,0.987,2.588,0.987,3.576,0L53.5,29.28L53.5,5H30.22z M43.5,19c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4
    		C47.5,17.209,45.709,19,43.5,19z"/>
    	<path style="fill:#28685C;" d="M43.5,7c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8S47.918,7,43.5,7z M43.5,19
    		c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C47.5,17.209,45.709,19,43.5,19z"/>
    	<path style="fill:#FDD7AD;" d="M43.5,16c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l14-14
    		c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-14,14C44.012,15.902,43.756,16,43.5,16z"/>
    	<path style="fill:#FFFFFF;" d="M22.55,44.399c-1.971,0-3.862-0.777-5.268-2.183c-2.905-2.905-2.905-7.633,0-10.538
    		c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414c-2.125,2.126-2.125,5.584,0,7.71c1.137,1.137,2.71,1.713,4.312,1.578
    		c0.806-0.067,1.539-0.461,2.063-1.107c0.553-0.683,0.808-1.574,0.699-2.447l-1.326-10.605c-0.176-1.411,0.235-2.853,1.13-3.956
    		c0.871-1.073,2.096-1.727,3.45-1.839c2.193-0.181,4.338,0.603,5.892,2.156c2.905,2.905,2.905,7.633,0,10.538
    		c-0.391,0.391-1.023,0.391-1.414,0s-0.391-1.023,0-1.414c2.125-2.126,2.125-5.584,0-7.71c-1.137-1.136-2.703-1.714-4.312-1.578
    		c-0.806,0.067-1.539,0.461-2.063,1.107c-0.553,0.682-0.808,1.574-0.699,2.447l1.326,10.605c0.176,1.41-0.236,2.853-1.13,3.955
    		c-0.871,1.074-2.096,1.728-3.45,1.84C22.966,44.391,22.758,44.399,22.55,44.399z"/>
    	<path style="fill:#FFFFFF;" d="M16.533,43.968c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l18.818-18.818
    		c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414L17.24,43.675C17.044,43.87,16.789,43.968,16.533,43.968z"/>
    </g>

  </svg>

</template>

<script>
export default {
  name: 'PriceTag',
  props: {
    circleFill: {
      default: '#bdcdda'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/menu/PriceTag.vue